module.exports = __webpack_public_path__ + "statics/img/12.b0aeaee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/home/12.png
// module id = Q3md
// module chunks = 1